import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RoutePages } from './enum/route-pages';
import { NewEnvelopeComponent } from './envelope/new-envelope/new-envelope.component';
import { MainEnvelopeComponent } from './main-envelope/main-envelope.component';
import { SentComponent } from './envelope/sent/sent.component';
import { AuthServiceResolver } from './core/resolvers/auth-service-resolver.service';
import { AuthSentServiceResolver } from './core/resolvers/auth-sent-resolver.service';
import { RedirectSuiteComponent } from '../app/pages/redirect-suite/redirect-suite.component';
import { ProfileValidateTeams } from './envelope/services/profileValidate.service';
import { InitialValidationResolverService } from './modules/signature/services/initial-validation-resolver.service';
import { EnvelopeEditComponent } from './envelope/envelope-edit/envelope-edit.component';
import { UserTypes } from './enum/user-types';
import { DashboardResolver } from './core/resolvers/dashboard-resolver';

export const routes: Routes = [
  {
    path: RoutePages.Root,
    redirectTo: RoutePages.Root,
    pathMatch: 'full',
    resolve: { AuthServiceResolver },
  },
  {
    path: RoutePages.MainEnvelope,
    component: MainEnvelopeComponent,
    data: {
      roles: [UserTypes.Admin, UserTypes.PowerUser],
    },
    canActivate: [ProfileValidateTeams],
  },
  {
    path: RoutePages.NewEnvelope,
    component: NewEnvelopeComponent,
  },
  {
    path: RoutePages.EditEnvelope + '/:envelopeId',
    component: EnvelopeEditComponent,
  },
  {
    path: RoutePages.SentEnvelope,
    component: SentComponent,
    resolve: {
      data: AuthSentServiceResolver,
    },
  },
  {
    path: RoutePages.InboxEnvelope,
    loadChildren: () =>
      import('./modules/inbox/inbox.module').then((m) => m.InboxModule),
    data: {
      roles: [UserTypes.Admin, UserTypes.PowerUser, UserTypes.User],
    },
    canActivate: [ProfileValidateTeams],
  },
  {
    path: RoutePages.Reports,
    loadChildren: () =>
      import('./modules/reports/reports.module').then((m) => m.ReportsModule),
    resolve: { AuthServiceResolver },
    data: { roles: [UserTypes.Admin, UserTypes.PowerUser] },
    canActivate: [ProfileValidateTeams],
  },
  {
    path: RoutePages.Settings,
    loadChildren: () =>
      import('./modules/settings/settings.module').then(
        (m) => m.SettingsModule
      ),
    resolve: { AuthServiceResolver },
    data: { roles: [UserTypes.Admin] },
    canActivate: [ProfileValidateTeams],
  },
  {
    path: RoutePages.Signature,
    loadChildren: () =>
      import('./modules/signature/signature.module').then(
        (m) => m.SignatureModule
      ),
    resolve: { data: InitialValidationResolverService },
  },
  {
    path: RoutePages.VerificationPortal,
    loadChildren: () =>
      import('./modules/verification/verification.module').then(
        (m) => m.VerificationModule
      ),
  },
  {
    path: RoutePages.Contacts,
    loadChildren: () =>
      import('./modules/contacts/contacts.module').then(
        (m) => m.ContactsModule
      ),
    data: {
      roles: [UserTypes.Admin, UserTypes.PowerUser],
    },
    canActivate: [ProfileValidateTeams],
  },
  {
    path: RoutePages.FeedbackPortal,
    loadChildren: () =>
      import('./modules/feedback-portal/feedback-portal.module').then(
        (m) => m.FeedbackPortalModule
      ),
    resolve: { AuthServiceResolver },
    data: {
      roles: [UserTypes.Admin, UserTypes.PowerUser, UserTypes.User],
    },
    canActivate: [ProfileValidateTeams],
  },
  {
    path: RoutePages.Dashboard,
    loadChildren: () =>
      import('./modules/dashboard/dashboard.module').then(
        (m) => m.DashboardModule
      ),
    resolve: { data: DashboardResolver },
    data: {
      roles: [UserTypes.Admin, UserTypes.PowerUser, UserTypes.User],
    },
    canActivate: [ProfileValidateTeams],
  },
  {
    path: RoutePages.PaidDashboard,
    loadChildren: () =>
      import('./modules/paid-dashboard/paid-dashboard.module').then(
        (m) => m.PaidDashboardModule
      ),
    resolve: { AuthServiceResolver },
    data: { roles: [UserTypes.Admin] },
    canActivate: [ProfileValidateTeams],
  },
  { path: RoutePages.Suite, component: RedirectSuiteComponent },
  { path: '**', component: RedirectSuiteComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
